import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ListingCard from 'src/components/elements/listing-card/ListingCard'
import { useGetRecommendedPropertiesQuery } from 'src/redux/api'
import ErrorState from 'src/components/elements/error-state/ErrorState'

// Personalised "Recommended for you" strip on the cabinet (roadmap 41): picks
// based on the user's recent views, falling back to fresh listings. Hidden when
// there is nothing to show.
const RecommendedListings: FC = () => {
  const { t } = useTranslation()
  const { data, isError, refetch } = useGetRecommendedPropertiesQuery()

  if (isError) {
    return (
      <section className="mt-2 flex flex-col gap-3">
        <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
          {t('recommended.title')}
        </h2>
        <ErrorState onRetry={refetch} />
      </section>
    )
  }
  if (!data || data.length === 0) return null

  return (
    <section className="mt-2 flex flex-col gap-3">
      <h2 className="text-xl md:text-[1.375rem] font-extrabold leading-tight text-ink">
        {t('recommended.title')}
      </h2>
      <div className="flex gap-4 overflow-x-auto -mx-4 px-4 scroll-px-4 pb-2 snap-x">
        {data.map((item) => (
          <ListingCard
            key={item.id}
            id={item.id}
            href={`/announcement/${item.id}`}
            variant="compact"
            className="shrink-0 w-[13.75rem] snap-start"
            images={item.images || []}
            alt={item.addressString || ''}
            price={item.price}
            listingType={item.listingType}
            propertyType={item.propertyType}
            location={item.addressString}
            topLeft={
              item.isPromoted && (
                <span className="px-2 py-0.5 text-xs font-black text-white bg-brand-strong rounded-lg">
                  {t('MapPage.top-badge')}
                </span>
              )
            }
          />
        ))}
      </div>
    </section>
  )
}

export default RecommendedListings
